import { render } from "./ItemViewDark.vue?vue&type=template&id=09cbd983&scoped=true"
import script from "./ItemViewDark.vue?vue&type=script&lang=js"
export * from "./ItemViewDark.vue?vue&type=script&lang=js"

import "./ItemViewDark.vue?vue&type=style&index=0&id=09cbd983&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cbd983"]])

export default __exports__